import React from "react";

import { Link } from "gatsby";
import ReactSVG from "src/components/ReactSVG";

import { default as infoIcon } from "../../../images/info.svg";
import { default as plusIcon } from "../../../images/plus.svg";
import { default as syrupIcon } from "../../../images/syrup.svg";
import { default as suppositoriesIcon } from "../../../images/suppositories.svg";
import { default as calendarIcon } from "../../../images/calendar-calculator.svg";

const otherCalculators = [
  {
    title: "cyklu dla dziewczynek",
    icon: calendarIcon,
    path: "/kalkulatory/cykl-dla-dziewczynek",
  },
  {
    title: "objętości syropu przeciwgorączkowego",
    icon: syrupIcon,
    path: "/kalkulatory/objetosc-syropu-przeciwgoraczkowego",
    c2a: "Policz teraz!",
  },
  {
    title: "dawki czopków przeciwgorączkowych",
    icon: suppositoriesIcon,
    path: "/kalkulatory/czopki",
    c2a: "Sprawdź dawkę",
  },
];

export const OtherCalculators = () => (
    <div className="px-2.5">
        <h3 className="text-s md:text-xl mt-9 md:mt-14 font-bold mb-4 md:mb-6">
          Sprawdź również:
        </h3>
        <div className="md:flex md:space-x-6">
          {otherCalculators.map(({ title, icon, path }, i) => (
            <Link key={path} to={path}>
              <div className="mb-4 flex space-x-3 md:space-x-4 items-center rounded-sm">
                <div className="rounded-full bg-blue-3 w-10 md:w-14 h-10 md:h-14 flex-shrink-0 flex justify-center items-center">
                  <ReactSVG className="w-5 md:w-7" path={icon} />
                </div>
                <div>
                  <div className="text-xs leading-4 md:text-grey-9 font-semibold">
                    Kalkulator {title}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
);